import React from 'react';
import './VideoMagnet.css';

const VideoLoader = () => {
  return (
    <div className="pulse-wrapper">
      <div className="pulse">
        <span />
        <span />
      </div>
    </div>
  );
};

export default VideoLoader;
